import { render, staticRenderFns } from "./GroupedListTitle.vue?vue&type=template&id=1547c31f&lang=pug"
import script from "./GroupedListTitle.vue?vue&type=script&lang=js"
export * from "./GroupedListTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports